import { render, staticRenderFns } from "./fio.vue?vue&type=template&id=0d12065b&"
import script from "./fio.vue?vue&type=script&lang=js&"
export * from "./fio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports